export default __webpack_public_path__ + "static/helfy-meals-781d041246cd6718a924fc38e49d690f.jpg";